import { Directive, HostListener, Input, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';
import { formatBusinessNumber, formatContactNumber } from '@millionshow/common';

@Directive({
  selector: '[appFormatInput]',
  standalone: true,
})
export class FormatInputDirective {
  @Input() appFormatInput: 'phone' | 'business' = 'phone';

  constructor(@Optional() private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let formatted: string;

    // 포맷 타입에 따라 다른 포맷터 사용
    if (this.appFormatInput === 'business') {
      formatted = formatBusinessNumber(input.value);
    } else {
      formatted = formatContactNumber(input.value);
    }

    // FormControl에 포맷된 값 설정
    if (this.ngControl && this.ngControl.control) {
      this.ngControl.control.setValue(formatted, { emitEvent: false });
    }

    // input 엘리먼트 값도 업데이트 (커서 위치 유지)
    const selectionStart = input.selectionStart;
    input.value = formatted;

    // 커서 위치 복원
    if (selectionStart !== null) {
      input.setSelectionRange(selectionStart, selectionStart);
    }
  }
}
